import {
  authTokenInterceptor,
} from '@shared/interceptors/auth-token.interceptor';
import { errorInterceptor } from '@shared/interceptors/error.interceptor';
import { apiRequestInterceptor } from './api-request.interceptor';

export default [
  authTokenInterceptor,
  apiRequestInterceptor,
  errorInterceptor,
];
